import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useRevalidator } from 'react-router';
import { useInvalidateSession } from '../../auth/session.js';
import { useShellContext } from '../shell/context.js';
import { CarteDoubleAuthentification } from './CarteDoubleAuthentification.js';
import styles from './ReglagesSecuritePage.module.css';

/** Réglages › Sécurité (mission S3-i, point 5) : la double authentification du compte. */
export function ReglagesSecuritePage(): JSX.Element {
  const { t } = useTranslation('regie');
  const { compte } = useShellContext();
  const invaliderSession = useInvalidateSession();
  const revalidateur = useRevalidator();

  return (
    <div className={styles.page}>
      <h1 className={styles.titre}>{t('reglages.securite.titre')}</h1>
      <p className={styles.sousTitre}>{t('reglages.securite.sousTitre')}</p>
      <CarteDoubleAuthentification
        actif={compte.deuxiemeFacteurActive}
        apresChangement={async () => {
          // La coquille relit la session : le rappel de la grâce disparaît.
          await invaliderSession();
          await revalidateur.revalidate();
        }}
      />
    </div>
  );
}
